/*
 * Jira Ticket:
 * Created Date: Wed, 18th Mar 2020, 11:56:29 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import edit from './edit';
import { Person as icon } from '@material-ui/icons';

export default {
  list,
  edit,
  icon,
};
